export const chapters: { name: string; id: string; illu: string }[] = [
  {
    name: '1. Wie die Naturwissenschaft den Himmel leer räumte',
    id: 'chapter_1',
    illu: 'vignetten_1.jpg'
  },
  {
    name: '2. Wie die Naturwissenschaft den Mikrokosmos entzauberte',
    id: 'chapter_2',
    illu: 'vignetten_2.jpg'
  },
  {
    name: '3. Wie die Naturwissenschaft den Menschen entzaubert',
    id: 'chapter_3',
    illu: 'vignetten_3.jpg'
  },
  {
    name: '4. Werden bald alle Rätsel gelöst sein?',
    id: 'chapter_4',
    illu: 'vignetten_7.jpg'
  },
  {
    name: '5. Das Bedürfnis nach Spiritualität und Trost',
    id: 'chapter_5',
    illu: 'vignetten_5.jpg'
  },
  {
    name: '6. Wie der Himmel wieder eingeräumt wird',
    id: 'chapter_6',
    illu: 'vignetten_6.jpg'
  },
  {
    name: '7. Wie Glauben und Wissen zusammenkommen',
    id: 'chapter_7',
    illu: 'vignetten_4.jpg'
  }
]
